import React from "react";
import { useLenis } from "../hooks/useLenis";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { TrustBar } from "../components/TrustBar";
import { CollabCards } from "../components/CollabCards";
import { Process } from "../components/Process";
import { Marquee } from "../components/Marquee";
import { Lifestyle } from "../components/Lifestyle";
import { Technology } from "../components/Technology";
import { CaseStudies } from "../components/CaseStudies";
import { Security } from "../components/Security";
import { MoreThanAgency } from "../components/MoreThanAgency";
import { ApplyForm } from "../components/ApplyForm";
import { Faq } from "../components/Faq";
import { Footer } from "../components/Footer";
import { WhatsAppFloat } from "../components/WhatsAppFloat";
import { useSeo } from "../hooks/useSeo";

export default function Landing() {
  useLenis();
  useSeo({
    title: "PMPOINT — Rekrutacja twórczyń 18+ | Marketing, sprzedaż i technologia dla OnlyFans, Fansly, MYM",
    description: "PMPOINT to agencja marketingowa dla twórczyń 18+. Rekrutujemy modelki do współpracy na OnlyFans, Fansly, Fanvue, MYM i innych platformach. Strategia, czatowanie, automatyzacja i rozliczenie procentowe.",
    canonical: "https://pmpoint.pl/",
  });
  return (
    <div className="bg-graphite text-white min-h-screen">
      <Nav />
      <main>
        <Hero />
        <TrustBar />
        <CollabCards />
        <Process />
        <Marquee />
        <Lifestyle />
        <Technology />
        <CaseStudies />
        <Security />
        <MoreThanAgency />
        <ApplyForm />
        <Faq />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
